import React from 'react';

const VistityBlock = block => (
  <div className="w-100 relative clearfix" style={{ display: 'none' }}>
    <iframe
      className="vistity-iframe"
      title={block.block.vistityTitle || 'Virtual Tour'}
      src={block.block.vistityUrl}
      id="tour-iframe"
      style={{ height: '100%', width: '100%' }}
    />
  </div>
);

export default VistityBlock;



// WEBPACK FOOTER //
// ./src/components/Blocks/VistityBlock.js